import Swiper, { EffectFade, FreeMode, Lazy, Navigation, Pagination, Scrollbar, Thumbs } from 'swiper';
import 'swiper/css';
import 'swiper/css/effect-fade';

import 'swiper/css/navigation';
import 'swiper/css/pagination';

let enabledZoom = false;
const zoomImageProduct = (page) => {
    $('.zoomContainer').remove();
    $('.zoomIco').removeClass('active');


    if(enabledZoom){
        $('.zoomIco').addClass('active');
        $('.gallery .image-product')
        .eq(page)
        .ezPlus({
            zoomType: window.innerWidth <= 640 ? 'inner' : 'window',
            zoomWindowPosition: 10,
        });
    }
    
};

function initialize() {
    let swiperThumbs;


    if ($('.gallery .swiper-gallery-thumbs').length > 0) {
        swiperThumbs = new Swiper('.gallery .swiper-gallery-thumbs', {
            modules: [Navigation, Pagination, Lazy, FreeMode, Thumbs, Scrollbar],

            direction: 'horizontal',
            freeMode: false,
            centerInsufficientSlides: false,
            
            breakpoints: {
                0: {
                    spaceBetween: 8,
                    slidesPerView: 'auto',
                },
                768: {
                    spaceBetween: 18,
                    slidesPerView: 4,
                },
            },
        });
    }

    const swiperGallery = new Swiper('.gallery .swiper-gallery', {
        modules: [Navigation, Pagination, Lazy, EffectFade, Thumbs],

        slidesPerView: 1,

        effect: 'fade',
        fadeEffect: {
            crossFade: true,
        },

        lazy: {
            enabled: true,
            loadPrevNext: true,
            loadPrevNextAmount: 1,
        },

        thumbs: {
            swiper: swiperThumbs,
        },

        navigation: {
            prevEl: '.gallery .btn-prev',
            nextEl: '.gallery .btn-next',
        },

        on: {
            init: () => {
                $('.gallery .image-container').each((i, element) => {
                    $(element).children('.zoomIco').on('click', function () {
                        enabledZoom = !enabledZoom;
                        zoomImageProduct(i);    
                    });

                });

            },
        },
    });

    swiperGallery.on('slideChange', function () {
        zoomImageProduct(this.realIndex);
    });
}

initialize();
